import {usePageContext}    from '@/context/PageContext'
import {useEffect, useRef} from 'react'
import gsap                from 'gsap'
import {ScrollTrigger}     from 'gsap/ScrollTrigger'

const useFooterAnimation = () => {
	const {pushingDesktopCanvasVideoRef} = usePageContext()

	const footerRef = useRef<HTMLDivElement>(null)

	useEffect(() => {
		gsap.registerPlugin(ScrollTrigger)

		const tl = gsap.timeline({
			scrollTrigger: {
				trigger:  footerRef.current,
				scrub:    true,
				start:    'top bottom',
				end:      'bottom bottom',
				onUpdate: (e) => pushingDesktopCanvasVideoRef.current && pushingDesktopCanvasVideoRef?.current.style.setProperty('--footer-progress', e.progress),
			},
		})
		return () => {
			tl.kill()
		}
	}, [])

	return {
		footerRef,
	}
}
export default useFooterAnimation